<template>
	<NuxtLayout>
		<div class="turneo">
			<div class="turneo__Title container">
				<h1>{{ page?.title }}</h1>
				<p>{{ page?.description }}</p>
			</div>
			<CMSField v-if="page?.content" :data="page.content" />
		</div>
	</NuxtLayout>
</template>

<script setup>
	defineOptions({
    auth: 'aminess'
  });
  
  defineProps({
    page: {}
  });
</script>

<style lang="scss">
	@import url('@/assets/styles/pages/_turneo.scss');
	@import url('@/assets/styles/components/blocks/_experiences.scss');
</style>